import configData from '../../config.json';
import { getApiLanguage } from '../../utils/app/language';
import httpClient from './httpClient';

export function fetchTranslations(token, rmc, options = {}) {
  return httpClient.get('/Translations', {
    token,
    query: {
      language: getApiLanguage(options.language),
      rmc,
      'subscription-key': configData.subscriptionkey,
    },
    responseType: 'json',
    signal: options.signal,
  });
}
